import * as THREE from 'three';
import type { Vec3 } from '@/types';

export const clamp = THREE.MathUtils.clamp;
export const lerp = THREE.MathUtils.lerp;
export const damp = THREE.MathUtils.damp;
export const mapLinear = THREE.MathUtils.mapLinear;
export const smoothstep = THREE.MathUtils.smoothstep;

/** Frame-rate independent smoothing factor from a per-60fps-frame ratio. */
export function smoothingFactor(ratioPerFrame: number, deltaSeconds: number): number {
  return 1 - Math.pow(1 - clamp(ratioPerFrame, 0, 1), deltaSeconds * 60);
}

/** Write a Vec3 tuple into a (reused) THREE.Vector3. */
export function toVector3(tuple: Vec3, target: THREE.Vector3 = new THREE.Vector3()): THREE.Vector3 {
  return target.set(tuple[0], tuple[1], tuple[2]);
}
